/**
 * Created by lu on 2018/5/4.
 */
var io = require('../io');
module.exports = function (inOpts) {
    inOpts.url = io.b2bCgiUrl;
    inOpts.cmd = 'order/confirmReceiving';
    io.ajax(inOpts);
};


//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/order/confirmGoods.js
// module id = 169
// module chunks = 3 8